import { resetAuthSessionInvalidGuard } from "./authSessionEvents";

const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refresh_token";

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);

export const getRefreshToken = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_KEY);

export const setToken = (token: string, refreshToken?: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  // 새 토큰 = 새 세션. 모든 로그인 플로우와 refresh 성공이 여기로 수렴하므로 세션 무효 가드 해제 지점은 이 한 곳이다(#405).
  resetAuthSessionInvalidGuard();
};

export const hasToken = (): boolean => !!getToken();

export const clearAllTokens = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  // 레거시 방어: 과거 빌드가 sessionStorage 에 남겼을 수 있는 토큰 잔재 청소 (현재 쓰기 경로 없음)
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
};
